export const API_URL = "https://hospital-api.app.bow.pet"
export const API_BOW_URL = "https://api.app.bow.pet";
// export const API_URL = "http://localhost:8081";
// export const API_BOW_URL = "http://0.0.0.0:8000"
